import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
// head
import { Link } from 'react-router-dom'

import './Head.css'
import { header } from '../constants'
import logo from './../assets/logo.svg'
import { useScrollSections, useScrollSection } from 'react-scroll-section'

export default function HeadCustom() {

    return (
        <div className='head'>
            <div className='head__left'>
                <Link to='/login'>
                    <button className='head__left__btn'>{header.action}</button>
                </Link>
            </div>
            <div className='head__right__custom'>


                <Link to={"/"} className='head__right_link'>
                    {header.landing_page}
                    {/* <HomeIcon/> */}
                </Link>
                <img src={logo} alt='logo' />
                <div className='head__right_link_small'>
                    <TemporaryDrawer />
                </div>
            </div>

        </div>
    )
}






const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    litem: {
        textAlign: 'end',
        fontFamily: 'Cairo bold'
    },
    lbtn: {
        paddingLeft: 10,
        paddingRight: 10
    }
});


function TemporaryDrawer() {
    const aboutSection = useScrollSection('about');
    const homeSection = useScrollSection('home');
    const contactSection = useScrollSection('contact_us')

    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const menuElement = []
    menuElement.push({ ...homeSection, text: header.landing_page })
    menuElement.push({ ...aboutSection, text: header.who_are_we })
    menuElement.push({ ...contactSection, text: header.contactus })
    menuElement.push({ ...contactSection, text: header.rdv })

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                {menuElement.map(({ id, onClick, selected, text }) => (

                    <ListItem button key={text} onClick={onClick} selected={selected}>
                        {/* <div onClick={sections[index].onClick}> */}
                        <ListItemText className={classes.litem} onClick={() => console.log("clicked")} primary={text} />
                        {/* </div> */}
                        {/* <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon> */}

                    </ListItem>
                ))}
            </List>
            <Divider />
            <List className={classes.lbtn} >
                <button className='head__left__btn__small'>{header.action}</button>

            </List>
        </div>
    );

    return (
        <div>
            {['right'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <Button onClick={toggleDrawer(anchor, true)}><MenuIcon /></Button>
                    <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                        {list(anchor)}
                    </Drawer>
                </React.Fragment>
            ))}
        </div>
    );
}